define("calendar/components/calendar/onboarding/wizards/schedule-first-post-successful/footer", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <@slide.finishButton @buttonClass="o--btn o--btn--block o--btn--outline" @text={{t "shared_words.done"}} />
  */
  {
    "id": "bIVpSa8x",
    "block": "[[[8,[30,1,[\"finishButton\"]],null,[[\"@buttonClass\",\"@text\"],[\"o--btn o--btn--block o--btn--outline\",[28,[37,0],[\"shared_words.done\"],null]]],null]],[\"@slide\"],false,[\"t\"]]",
    "moduleName": "calendar/components/calendar/onboarding/wizards/schedule-first-post-successful/footer.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});